// the app config
export const DEFAULT_LANG = 'fa';
export const DEFAULT_PAGETITLE = 'PAGE_TITLE';
export const DEFAULT_TITLE = 'PISHKHAN';

// sentry
export const SENTRY_DSN =
  'https://22c9a67ac4f2411eb876753c17109d96@sentry.cafebazaar.org/57';

// login with google
export const GOOGLE_OAUTH2_CLIENT_ID =
  '324971023621-use7cqlj8u2lmd7vlkgg9d8gg1gverin.apps.googleusercontent.com';
// envs

export const hostname =
  (process.env.NODE_ENV !== 'testing' && window.location.hostname) ||
  'pishkhan.cafebazaar.ir';

export const ENVIRONMENT =
  process.env.NODE_ENV === 'testing'
    ? 'testing'
    : hostname === 'pishkhan.cafebazaar.ir'
    ? 'production'
    : 'development';

export const IS_STAGING = ENVIRONMENT !== 'production';
export const IS_PRODUCTION = ENVIRONMENT === 'production';

export const ARCAPTCHA_SITEKEY = 'k8781ptj0t';

export const ARCAPTCHA_ENABLE = false;

export const PREFIX_PATH =
  process.env.VUE_APP_STAGE === 'branch' ? process.env.BASE_URL : '/';
